export default {module:'Card/Form',view:'Element/Section',children:[{config:'ui/attachment/type/pdf'}]}